<div class="tiny-padding-all row-container">
  <div>
    <strong>{{ file?.fileName }}</strong>
    @if (!file.completed && file.error) {
      <p class="warn-text">{{file.error}}</p>
    }
  </div>
  <div class="tiny-padding-all text-align-right">
    @if (file.error) {
      <button type="button" class="btn btn-success btn-xs" (click)="uploadFile()">
        <svg-icon title="File Upload" icon="icon-upload" class="dark-gray" aria-hidden="true"></svg-icon>
      </button>
    }
    @if (allowDeletion) {
      <button [attr.disabled]="file.completed ? null : 'disabled'" type="button" attr.aria-label="Delete file'{{file?.fileName}}'" (click)="deleteFile()">
        <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
      </button>
    }
    @if (file.completed || file.isUploading) {
      <button [attr.disabled]="file.completed ? null : 'disabled'" type="button" attr.aria-label="Download file'{{file?.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile()">
        <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
      </button>
    }
  </div>
</div>
<div class="progress-bar tiny-padding-all">
  <div class="progress no-margin" role="progressbar" aria-valuemin="0" aria-valuemax="100">
    <div class="progress-meter" [ngStyle]="{ 'width': file.percentage + '%' }"></div>
  </div>
</div>